import { useEffect } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider as StoreProvider } from 'react-redux';
import { ThemeProvider } from '@nazka/nazka.mapframe.components';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

import TranslationsProvider, { LocalizedRoutes } from '@utils/i18n/i18n';
import WindowObserver from '@utils/WindowObserver/WindowObserver';
import ErrorBoundary from '@utils/ErrorBoundary/ErrorBoundary';
import Cookies from '@utils/Cookies/Cookies';
import routes from '@App/app.routes';
import store from '@App/app.store';
import translator from '@App/app.translator';
import theme from '@style/theme.json';

const queryClient = new QueryClient();

function App() {
  const renderRoute = ({ path, index, element, children }) => (
    <Route path={path} index={index} element={element} key={path ?? `index-${children?.length ?? 0}`}>
      {children?.map(renderRoute)}
    </Route>
  );

  useEffect(() => document.documentElement.setAttribute('data-app-initialised', true), []);

  return (
    <QueryClientProvider client={queryClient}>
      <StoreProvider store={store}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <ErrorBoundary>
              <TranslationsProvider translator={translator}>
                <LocalizedRoutes>
                  {routes.map(renderRoute)}
                </LocalizedRoutes>
                <Cookies useConfig />
              </TranslationsProvider>
            </ErrorBoundary>
          </BrowserRouter>
        </ThemeProvider>
        <WindowObserver />
      </StoreProvider>
    </QueryClientProvider>
  );
}

export default App;
